<template>
  <v-container>
    <Breadcrumbs :crumbs="crumbs" />
    <PageHeader>
      <template v-slot:header>プラスの氣 返信BOX</template>
      <template v-slot:annotation> あなたが返信したプラスの氣の一覧</template>
    </PageHeader>

    <div class="text-center px-3">
      <v-row>
        <DatePicker v-model="dateFrom" label="表示開始日" />
        <DatePicker v-model="dateTo" label="表示終了日" />

        <v-col>
          <Button @click="get_comment(true)" color="primary">絞り込み</Button>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card-subtitle class="text-right"
            >返信メッセージは「{{ searchNum }}」件です。</v-card-subtitle
          >
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            @click:row="onClickOpen"
            :loading="loading"
            loading-text="読み込み中..."
            no-data-text="プラスの氣返信一覧は見つかりませんでした。表示期間を再確認してください。"
          >
            <template v-slot:[`item.SHOW_SEND_TIME`]="{ item }">
              <YearMonthDay
                :value="item.SHOW_SEND_TIME"
                format="YYYY/MM/DD HH:mm"
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <detail ref="detail" @detail="get_comment(false)"></detail>

    <DialogMessage ref="dialog" />
  </v-container>
</template>

<script>
import { generateMessage } from '@/utils/common.js';
import { format } from '@/utils/day.js';
import axios from 'axios';
import moment from 'moment';
import config from '../../../const.js';
import message from '../../../message.js';
import detail from '@/components/pages/Encouragements/DetailDialog.vue';
import {
  getSessionStorageItem,
  makeDateTimeStr,
  substr,
  makeDateFormatStr,
} from '../../../common.js';
export default {
  components: {
    detail,
  },
  data() {
    return {
      // Breadcrumbs
      crumbs: [
        {
          name: 'プラスの氣 返信BOX',
          route: 'EncouragementsReplyList',
        },
      ],

      // 変数宣言
      showContent: false,
      loading: false,
      searchNum: 0,

      // パラメータ
      userId: '',
      sessionId: '',
      organizationName: '',
      userName: '',
      positionName: '',
      dateFrom: '',
      dateTo: '',
      // 自分自身のプラスの氣取得
      items: [],
      headers: [
        {
          text: '日時',
          align: 'left',
          sortable: true,
          value: 'SHOW_SEND_TIME',
          width: '15%',
        },
        {
          text: '返信先',
          align: 'left',
          sortable: true,
          value: 'TO_USER_NAME',
          width: '20%',
        },
        {
          text: '内容',
          align: 'left',
          sortable: false,
          value: 'SHOW_SUBTITLE',
          width: '46%',
        },
        {
          text: 'いいね!',
          align: 'left',
          sortable: true,
          value: 'NICE_COUNT',
          width: '9%',
        },
      ],
    };
  },
  created() {
    // From date
    let dtFrom = moment().subtract(1, 'days').format('YYYY-MM-DD');
    this.dateFrom = dtFrom;

    // To date
    let dtTo = moment().format('YYYY-MM-DD');
    this.dateTo = dtTo;

    // プラスの氣一覧取得
    this.get_comment(true);
  },
  methods: {
    onClickOpen(item) {
      this.$refs.detail.open(item);
    },
    get_comment(search_flg) {
      // ユーザ情報取得
      let userInfo = getSessionStorageItem();

      // セッションチェック
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        return;
      }

      // 日付From Toチェック
      if (
        makeDateTimeStr('S', this.dateFrom) > makeDateTimeStr('E', this.dateTo)
      ) {
        this.$refs.dialog.open('warning', message.MSG_WARN_DATE_ERROR);
        // From date
        let dtFrom = moment().subtract(1, 'days').format('YYYY-MM-DD');
        this.dateFrom = dtFrom;

        // To date
        let dtTo = moment().format('YYYY-MM-DD');
        this.dateTo = dtTo;
        return;
      }

      // 件数初期化
      this.searchNum = 0;

      // ローディング画像表示
      this.loading = true;

      let vm = this;
      vm.items = [];

      //----- プラスの氣取得(ユーザ自身)リクエストGET
      axios
        .get(
          config.CONNECT_URL +
            '/Encouragements/myselfComments/' +
            userInfo.SESSION_ID +
            '/' +
            userInfo.USER_ID +
            '/' +
            makeDateTimeStr('S', this.dateFrom) +
            '/' +
            makeDateTimeStr('E', this.dateTo) +
            '/' +
            config.PURASUNOKI_SEARCH_REPLY
        )
        .then((response) => {
          // プラスの氣データ取得
          vm.items = response.data;

          // 表示データ整形
          this.searchNum = 0;
          for (var i = 0; i < vm.items.length; i++) {
            vm.items[i].SEND_USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              vm.items[i].SEND_USER_AVATER +
              '?' +
              format('YYYYMMDDHHmmss');
            vm.items[i].TO_USER_AVATER =
              config.S3_END_POINT +
              config.AVATER_DIRECTORY +
              vm.items[i].TO_USER_AVATER +
              '?' +
              format('YYYYMMDDHHmmss');
            vm.items[i].SHOW_SUBTITLE = substr(
              vm.items[i].SEND_COMMENT,
              33,
              '...'
            );
            if (vm.items[i].NICE_COUNT == 0) {
              vm.items[i].NICE_COUNT = '';
            }
            vm.items[i].SEND_START_WORKING_AT = makeDateFormatStr(
              vm.items[i].SEND_START_WORKING_AT,
              '/',
              '/',
              ''
            );
            vm.items[i].TO_START_WORKING_AT = makeDateFormatStr(
              vm.items[i].TO_START_WORKING_AT,
              '/',
              '/',
              ''
            );
            this.searchNum++;
          }

          // 検索結果が最大件数のメッセージ
          if (search_flg) {
            if (this.searchNum == config.PURASUNOKI_MAX_NUM) {
              let infoStr = message.MSG_INFO_PURASUNOKI_LIST_MAX;
              let infoStrReplace = infoStr.replace(
                /a/g,
                config.PURASUNOKI_MAX_NUM
              );
              this.$refs.dialog.open('info', infoStrReplace);
            }
          }

          // ローディング画像終了
          this.loading = false;
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.response.status == 404) {
            errStr = generateMessage(message.NOT_FOUND, ['プラスの氣']);
            this.$refs.dialog.open('info', errStr);
          } else if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
  },
};
</script>
